import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/elementConfig'
import './plugins/echartsConfig'
import {i18n} from './plugins/i18n.js'
import dataV from '@jiaminghi/data-view'
import Axios from 'axios'

const apiOrigin = process.env.VUE_APP_API_ORIGIN || 'http://localhost:8000'
Axios.defaults.baseURL = `${apiOrigin}/api`
Axios.defaults.headers.post['Content-Type'] = 'application/json'

// 添加请求拦截器以包含授权令牌
Axios.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器以处理401错误
Axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response?.status === 401) {
    // 登录失效处理
    handleAuthFailure()
  } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
    // 请求超时处理
    Vue.prototype.$message.error('请求超时，请检查网络连接')
  } else if (!error.response) {
    // 网络错误处理
    Vue.prototype.$message.error('网络连接失败，请检查网络')
  }
  return Promise.reject(error)
})

// 统一的认证失败处理函数
function handleAuthFailure() {
  // 清除过期的认证信息
  localStorage.removeItem('access_token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('ms_username')
  localStorage.removeItem('userRole')
  localStorage.removeItem('savedUsername')
  
  // 更新Vuex状态
  store.commit('logout')
  
  // 提示用户登录已失效
  Vue.prototype.$message.warning('登录已失效，请重新登录')
  
  // 跳转到登录页
  if (router.currentRoute.path !== '/login') {
    router.push('/login')
  }
}

// 全局方法：手动退出登录
Vue.prototype.$logout = function() {
  // 清除所有认证相关的本地存储数据
  localStorage.removeItem('access_token')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('ms_username')
  localStorage.removeItem('userRole')
  localStorage.removeItem('savedUsername')
  
  // 更新Vuex状态
  store.commit('logout')
  
  // 提示用户
  Vue.prototype.$message.success('退出成功')
  
  // 跳转到登录页
  router.push('/login')
}

import {parseTime} from '@/views/excel/utils'

Vue.filter("parseTime", parseTime)
Vue.config.productionTip = false
Vue.use(dataV)
Vue.prototype.$http = Axios

// 初始化用户状态
store.dispatch('initUserState')

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')